import React from "react";
import PropTypes from "prop-types";

import CsLineIcons from "../../cs-line-icons";
import "./style.css";

const DataPanel = ({
    actions,
    children,
    description,
    icon,
    label,
    onViewChange,
    value,
    view,
}) => (
    <section className="licensee-data-panel">
        <header className="licensee-data-panel-header">
            <div className="licensee-data-panel-summary">
                <span className="licensee-data-panel-icon" aria-hidden="true">
                    <CsLineIcons icon={icon} size="25" />
                </span>
                <span className="licensee-data-panel-copy">
                    <span className="licensee-data-panel-label">{label}</span>
                    <strong>{value}</strong>
                    {description ? <span className="licensee-data-panel-description">{description}</span> : null}
                </span>
            </div>
            <div className="licensee-data-panel-actions">
                {actions}
                {onViewChange ? (
                    <div className="licensee-view-toggle" role="group" aria-label="Choose a result view">
                        <button
                            type="button"
                            className={view === "card" ? "active" : ""}
                            aria-pressed={view === "card"}
                            onClick={() => onViewChange("card")}
                        >
                            <CsLineIcons icon="credit-card" size="15" />
                            <span>Card View</span>
                        </button>
                        <button
                            type="button"
                            className={view === "table" ? "active" : ""}
                            aria-pressed={view === "table"}
                            onClick={() => onViewChange("table")}
                        >
                            <CsLineIcons icon="list" size="15" />
                            <span>Table View</span>
                        </button>
                    </div>
                ) : null}
            </div>
        </header>
        <div className="licensee-data-panel-body">{children}</div>
    </section>
);

DataPanel.defaultProps = {
    actions: null,
    description: "",
    icon: "file-text",
    onViewChange: null,
    view: "table",
};

DataPanel.propTypes = {
    actions: PropTypes.node,
    children: PropTypes.node.isRequired,
    description: PropTypes.string,
    icon: PropTypes.string,
    label: PropTypes.string.isRequired,
    onViewChange: PropTypes.func,
    value: PropTypes.node.isRequired,
    view: PropTypes.oneOf(["card", "table"]),
};

export default DataPanel;
